// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { string, boolean, number } from "@altostra/type-validations/lib/primitives";

export const isGetAppGroupsAppGroupIdPlacementsIdResult = objectOf({
  id: string,
  placement_id: string,
  name: string,
  description: string,
  marked_as_deleted: boolean,
  app_group_id: string,
  created_at: number,
  created_by_id: string,
  last_edited_at: number,
  last_edited_by_id: string,
});

export const isPatchAppGroupsAppGroupIdPlacementsIdResult = objectOf({
  id: string,
  placement_id: string,
  name: string,
  description: string,
  marked_as_deleted: boolean,
  app_group_id: string,
  created_at: number,
  created_by_id: string,
  last_edited_at: number,
  last_edited_by_id: string,
});
